<gridster [options]="options">
    @for (element of elements(); track element.id; let index = $index) {
        <gridster-item [item]="gridElements()[index]">
            <div class="panel" [class.active]="selectedElement()?.id === element.id">
                <div class="header">
                    <input type="text"
                           pSize="small"
                           class="name"
                           pInputText
                           [value]="element.data.content.name"
                           (mousedown)="$event.stopPropagation()"
                           (touchstart)="$event.stopPropagation()"
                           (change)="updateEditingElementName($any($event).target.value)"
                           [disabled]="selectedElement()?.id !== element.id">

                    <p-button [icon]="selectedElement()?.id === element.id ? 'pi pi-check' : 'pi pi-pencil'"
                              [severity]="selectedElement()?.id === element.id ? 'primary' : 'secondary'"
                              [outlined]="selectedElement()?.id !== element.id"
                              size="small"
                              (mousedown)="$event.stopPropagation()"
                              (touchstart)="$event.stopPropagation()"
                              (click)="toggleSelectedElement(element)"
                              [loading]="selectedElement()?.id === element.id && isElementLoading()"/>
                    <p-button icon="pi pi-times"
                              size="small"
                              severity="secondary"
                              outlined
                              (mousedown)="$event.stopPropagation()"
                              (touchstart)="$event.stopPropagation()"
                              (click)="removeElement(element.id)"/>
                </div>
                <dashboard-element-content [elementData]="element.data" [id]="element.id"/>
            </div>
        </gridster-item>
    }
</gridster>
